import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled, { css } from 'styled-components';
import { fontFamily } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import withTileAction from '../../util/withTileAction';
import { INSURANCE_SWIMLANE_COPAY_COINSURANCE_TAPPED } from '../../../../../../core/analytics/events';

const Root = styled.div.withConfig({ componentId: 'sc-1k6e6ov-0' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  letter-spacing: 0.2px;
`;

const Icon = styled.img.withConfig({ componentId: 'sc-1k6e6ov-1' })`
  width: 90px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-1k6e6ov-2' })`
  font-family: ${fontFamily.book};
  font-size: 18px;
  color: ${colors.squid};
  letter-spacing: 0.09px;
  margin: 15px 0 7px 0;
`;

const Subtext = styled.div.withConfig({ componentId: 'sc-1k6e6ov-3' })`
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  width: 85%;
  margin: 0 auto 25px;
  letter-spacing: normal;
  @media (min-width: 320px) and (max-width: 322px) {
    letter-spacing: -0.2px;
  }
  ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc.isCopay &&
    css`
      @media (min-width: 321px) and (max-width: 352px) {
        letter-spacing: -0.3px;
      }
      @media (min-width: 353px) and (max-width: 374px) {
        letter-spacing: -0.4px;
      }
      @media (min-width: 375px) and (max-width: 380px) {
        letter-spacing: -0.1px;
      }
    `}
`;

const PurpleBar = styled.div.withConfig({ componentId: 'sc-1k6e6ov-4' })`
  height: 4px;
  width: 100%;
  background-color: ${colors.purpSizzurp};
  border-radius: 8px 8px 0 0;
  margin-bottom: 20px;
`;

type Props = {
  tile: object;
  tileIndex: number;
  userProfile?: object;
  eventName?: string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  doTileAction?: func;
  insuranceProfile?: object;
  insuranceDetails?: object;
};

class CopayCoinsurance extends PureComponent<Props> {
  render = () => {
    const { tile, tileIndex, userProfile } = this.props;

    return (
      <Root
        onClick={() =>
          this.props.doTileAction(
            tileIndex,
            tile,
            userProfile,
            null,
            INSURANCE_SWIMLANE_COPAY_COINSURANCE_TAPPED
          )
        }
      >
        <PurpleBar />
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'icon' does not exist on type 'object'. */}
        <Icon src={tile.icon} />
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'object'. */}
        <Title>{tile.title}</Title>
        {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message */}
        <Subtext sc={{ isCopay: tile.title === 'Copay' }}>{tile.subtext}</Subtext>
      </Root>
    );
  };
}

export default withTileAction(CopayCoinsurance);
